import { render, staticRenderFns } from "./three_cross.vue?vue&type=template&id=04c437b9&scoped=true"
import script from "./three_cross.vue?vue&type=script&lang=js"
export * from "./three_cross.vue?vue&type=script&lang=js"
import style0 from "./three_cross.vue?vue&type=style&index=0&id=04c437b9&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c437b9",
  null
  
)

export default component.exports